import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type ModalManager from "cc-frontend/services/modal-manager"
import type Session from "cc-frontend/services/session"
import _ from "lodash"

@tagName("")
export default class WeekMenu extends Component {
  // Args
  courses!: Array<Course>
  planbook!: Planbook
  startDate!: string
  endDate!: string
  dateRangeString!: string
  isFilteringClasses!: boolean
  classesLinedUp!: boolean
  perspective!: string
  openOnHover!: boolean
  closeMenu!: Function
  hiddenCourseIds: Array<string> = []

  // Services
  @service modalManager!: ModalManager
  @service session!: Session

  // Actions
  @action
  printOrDownload() {
    this.closeMenu()

    if (this.session.isAuthenticated !== true) {
      this.session.mustSignInToProceed("Print/Download Day")
      return
    }

    if (_.includes(this.session.user.content.meta.permissions, "can-print-week")) {
      this.modalManager.openModal("planner/modals/print-download", {
        courseIds: _.chain(this.courses)
          .map((course) => course.id)
          .reject((courseId) => _.includes(this.hiddenCourseIds, courseId))
          .value(),
        isFilteringClasses: this.isFilteringClasses,
        classesLinedUp: this.classesLinedUp,
        planbookId: this.planbook.id,
        startDate: this.startDate,
        endDate: this.endDate,
        currentUserId: this.session.userId,
        dateRangeString: this.dateRangeString,
        layout: this.perspective,
        canPrint: _.includes(this.session.user.content.meta.permissions, "can-print-week"),
      })
    } else {
      this.modalManager.openModal("planner/modals/print-paywall", {})
    }
  }
}
